var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6001 53.55C13.6001 54.9026 14.1374 56.1998 15.0939 57.1562C16.0503 58.1127 17.3475 58.65 18.7001 58.65H54.1876C54.244 58.65 54.298 58.6276 54.3379 58.5877C54.3777 58.5479 54.4001 58.4938 54.4001 58.4375V58.0533C54.4001 57.5679 54.1799 57.1149 53.8697 56.7417C53.1127 55.8341 52.6987 54.6893 52.7001 53.5075C52.7001 52.2775 53.1395 51.1496 53.8697 50.2732C54.1799 49.8992 54.4001 49.447 54.4001 48.9617V48.5027C54.3999 48.4888 54.3943 48.4755 54.3844 48.4657C54.3746 48.4558 54.3613 48.4502 54.3474 48.45M18.7001 9.34998H53.5671C53.788 9.34998 53.9999 9.43774 54.1561 9.59396C54.3123 9.75017 54.4001 9.96205 54.4001 10.183V48.2375C54.4001 48.2938 54.3777 48.3479 54.3379 48.3877C54.298 48.4276 54.244 48.45 54.1876 48.45H18.7001C17.3843 48.4499 16.1193 48.9585 15.1697 49.8693C14.22 50.7801 13.6592 52.0228 13.6043 53.3375C13.6043 53.3417 13.6001 53.3417 13.6001 53.3375V14.45C13.6001 13.0974 14.1374 11.8002 15.0939 10.8437C16.0503 9.8873 17.3475 9.34998 18.7001 9.34998Z",
    stroke: "#FFF0F0",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/Icon1.7a981079d51c62a27f611dfd785cb8af.svg";
export { ForwardRef as ReactComponent };